// extracted by mini-css-extract-plugin
export default {"dateRangeContainer":"historyDateRangeFilter_dateRangeContainer__1JM0i"};